import { UserImage } from 'src/v2/components/UserImage';
import { PAYPAL_PAYMENT_IN_PROGRESS, SVG_SIZE_XXL } from 'src/constants';
import { useGetUser, useSession } from 'src/hooks';
import { getFullName } from 'src/utils';
import styles from './UserMenuMainInfo.module.scss';
import { PaypalPaymentInProgressPanel } from 'src/components/PaypalPaymentInProgressPanel/PaypalPaymentInProgressPanel';
import { getWithExpiry } from 'src/utils/localStorage';

export const UserMenuMainInfo = () => {
  const { appUser } = useSession();
  const { isOpenTier } = useGetUser();
  const userName = getFullName(appUser);

  const paypalPaymentInProgress =
    getWithExpiry(PAYPAL_PAYMENT_IN_PROGRESS) === 'true';

  return (
    <div className={styles.root}>
      <UserImage size={SVG_SIZE_XXL} iconSize={SVG_SIZE_XXL} isUserMenu />

      {!isOpenTier && (
        <div className={styles.content}>
          <p className={styles.name}>{userName}</p>
          {appUser.email && <p className={styles.email}>{appUser.email}</p>}
        </div>
      )}

      {paypalPaymentInProgress && <PaypalPaymentInProgressPanel />}
    </div>
  );
};
